export const APP_CONFIG = {
  SYNC_INTERVAL: 5 * 60 * 1000, // Sync interval in milliseconds (5 minutes)
  MIN_SYNC_INTERVAL: 30 * 1000, // Minimum time between sync attempts (30 seconds)
};

export const CACHE_CONSTANTS = {
  FIVE_MINUTES_IN_MS: 5 * 60 * 1000, // Five minutes in milliseconds
  TEN_MINUTES_IN_MS: 10 * 60 * 1000, // Ten minutes in milliseconds
  THIRTY_MINUTES_IN_MS: 30 * 60 * 1000, // Thirty minutes in milliseconds
  ONE_HOUR_IN_MS: 60 * 60 * 1000, // One hour in milliseconds
  ONE_MINUTE_IN_MS: 60 * 1000, // One minute in milliseconds
  ONE_DAY_IN_MS: 24 * 60 * 60 * 1000, // One day in milliseconds
  ONE_WEEK_IN_MS: 7 * 24 * 60 * 60 * 1000, // One week in milliseconds
};


export const TEE_COLORS = {
  BLACK: 'Black',
  BLUE: 'Blue',
  WHITE: 'White',
  GOLD: 'Gold',
  RED: 'Red',
  GREEN: 'Green',
  YELLOW: 'Yellow',
  PURPLE: 'Purple',
  ORANGE: 'Orange',
  BROWN: 'Brown',
  GRAY: 'Gray',
  SILVER: 'Silver',
  BURGUNDY: 'Burgundy',
  NAVY: 'Navy',
  ROYAL: 'Royal',
  COPPER: 'Copper',
  BRONZE: 'Bronze',
  PLATINUM: 'Platinum',
  JADE: 'Jade',
  FOREST: 'Forest',
  MAROON: 'Maroon',
  RUBY: 'Ruby',
  PINK: 'Pink',
  ROSE: 'Rose',
  CRIMSON: 'Crimson',
  WINE: 'Wine',
  TAN: 'Tan',
  KHAKI: 'Khaki',
  BRASS: 'Brass',
  SAGE: 'Sage',
  OLIVE: 'Olive',
  TEAL: 'Teal',
  AZURE: 'Azure',
  INDIGO: 'Indigo',
  VIOLET: 'Violet',
  DEFAULT: 'Default',
} as const;

export const TEE_COLOR_MAP: { [key: string]: { bg: string; text: string } } = {
  // Standard Colors
  'Default': { bg: '#e5e7eb', text: '#000000' },
  'Black': { bg: '#000000', text: '#FFFFFF' },
  'Blue': { bg: '#0066cc', text: '#FFFFFF' },
  'White': { bg: '#FFFFFF', text: '#000000' },
  'Red': { bg: '#cc0000', text: '#FFFFFF' },
  'Gold': { bg: '#FFD700', text: '#000000' },
  'Green': { bg: '#006400', text: '#FFFFFF' },
  'Yellow': { bg: '#FFFF00', text: '#000000' },
  'Purple': { bg: '#800080', text: '#FFFFFF' },
  'Orange': { bg: '#FFA500', text: '#000000' },
  'Brown': { bg: '#8B4513', text: '#FFFFFF' },
  'Gray': { bg: '#808080', text: '#FFFFFF' },
  'Silver': { bg: '#C0C0C0', text: '#000000' },
  'Burgundy': { bg: '#800020', text: '#FFFFFF' },

  // Additional Colors and Variations
  'Navy': { bg: '#000080', text: '#FFFFFF' },
  'Royal': { bg: '#4169E1', text: '#FFFFFF' },
  'Copper': { bg: '#B87333', text: '#FFFFFF' },
  'Bronze': { bg: '#CD7F32', text: '#FFFFFF' },
  'Platinum': { bg: '#E5E4E2', text: '#000000' },
  'Jade': { bg: '#00A86B', text: '#FFFFFF' },
  'Forest': { bg: '#228B22', text: '#FFFFFF' },
  'Maroon': { bg: '#800000', text: '#FFFFFF' },
  'Ruby': { bg: '#E0115F', text: '#FFFFFF' },
  'Pink': { bg: '#FFC0CB', text: '#000000' },
  'Rose': { bg: '#FF007F', text: '#FFFFFF' },
  'Crimson': { bg: '#DC143C', text: '#FFFFFF' },
  'Wine': { bg: '#722F37', text: '#FFFFFF' },
  'Tan': { bg: '#D2B48C', text: '#000000' },
  'Khaki': { bg: '#C3B091', text: '#000000' },
  'Brass': { bg: '#B5A642', text: '#FFFFFF' },
  'Sage': { bg: '#9DC183', text: '#000000' },
  'Olive': { bg: '#808000', text: '#FFFFFF' },
  'Teal': { bg: '#008080', text: '#FFFFFF' },
  'Azure': { bg: '#007FFF', text: '#FFFFFF' },
  'Indigo': { bg: '#4B0082', text: '#FFFFFF' },
  'Violet': { bg: '#8F00FF', text: '#FFFFFF' },
};

export const UI_CONSTANTS = {
  FONTS: {
    LARGE: 24,
    MEDIUM: 18,
    SMALL: 14,
  },
  SPACING: {
    SMALL: 8,
    MEDIUM: 16,
    LARGE: 24,
    XLARGE: 32,
  },
  BORDER_RADIUS: {
    SMALL: 4,
    MEDIUM: 8,
    LARGE: 12,
  },
  TRANSITIONS: {
    DEFAULT: '0.3s ease',
  },
};